import React from "react";

const MenuButton = props => {

  return (
    <button
    className={['z-20', 'flex', 'justify-center', 'items-center', 'no-underline', 'md:pb-6', 'tap',
    props.open ? 'text-white' : 'text-black',
    props.open ? 'arrowturnopen' : 'arrowturnclose',
    props.open ? 'transition' : 'transition',
    props.white ? 'md:text-white' : 'text-black'].join(" ")}
    >
    <span className="font-logo txtlogo tracking-tight">
      <h1 className="hidden md:block hover:text-pink">→</h1>
      <h1 className="md:hidden">↓</h1>
    </span>
  </button>
  
)};

export default MenuButton;


// WEBPACK FOOTER //
// ./src/components/Header/menuButton.js